//enums
import {TablesMeals} from '@/utils/enums';
import { emailSchema, phoneSchema } from '@/utils/validation';
import * as Yup from 'yup';

export type AttendeeDetailsFormValues = {
	id: number;
	email: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	address: string;
	city: string;
	state: string;
	zip: string;
	meals: TablesMeals[];
};

export const initialValues: AttendeeDetailsFormValues = {
	id: 0,
	email: '',
	firstName: '',
	lastName: '',
	phoneNumber: '',
	address: '',
	city: '',
	state: '',
	zip: '',
	meals: [],
};

export const validationSchema = () => {
	  return Yup.object().shape({
		firstName: Yup.string().required('First name is required').trim(),
		lastName: Yup.string().required('Last name is required').trim(),
		email: emailSchema.nullable().optional(),
		phoneNumber: phoneSchema.nullable(),
		address: Yup.string().optional().trim(),
		city: Yup.string().optional().trim(),
		state: Yup.string().optional().trim(),
		zip: Yup.string().optional().trim(),
	  });
};
